import { SessionStorageKeys, useSessionStorage } from '@/utils/storage.ts';
import { Language } from '@/api/types.ts';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect } from 'react';

export const DEFAULT_LANGUAGE = 'english';

export const useAppLanguage = () => {
  const [language, _setLanguage] = useSessionStorage<Language>(
    SessionStorageKeys.SELECTED_LANGUAGE,
    DEFAULT_LANGUAGE
  );
  const { i18n: { changeLanguage } } = useTranslation();

  useEffect(() => {
    changeLanguage(language);
  }, [language]);

  const setLanguage = useCallback((value) => {
    _setLanguage(value);
    changeLanguage(value);
  }, [_setLanguage]);

  return [language, setLanguage, _setLanguage] as const;
}
